import type { Profile } from '@/entities/profile';
import request from '@/shared/api/request';

/**
 *
 * Returns updated user Profile.
 *
 * @returns {Promise}
 */
export const updateProfile = (data: Partial<Profile>): Promise<{ profile: Profile }> =>
  request({
    url: '/account/profile/',
    method: 'PUT',
    data,
  });
